import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Typography,
  Rating,
  TextField,
  Button,
  Box,
  Paper,
  styled,
  Grid
} from "@mui/material";
import LandingCurrentDateTime from "../LandingCurrentDateTime";


const FullScreenContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: '100vh', // Ensure it fills the viewport height
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto', // Allows scrolling if content overflows
  //backgroundColor: 'gray', 
 // backgroundImage: `url(/assets/images/bookonline-bg1.jpg)`,
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url("/assets/images/bookonline-bg.jpeg")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'repeat',
  backgroundAttachment: 'fixed'
}));
const LogoBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "20px",
  left: "20px",
  backgroundColor: "#fff",
  padding: "10px 12px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
  zIndex: 99
}));


const FormContainer = styled(Paper)(({ theme }) => ({
  margin: theme.spacing(3),
  padding: theme.spacing(3),
  backgroundColor: 'rgb(255,255,255,0.8)',
  //borderRadius: theme.spacing(2),
}));

const FeedbackForm = () => {
  const [questions, setquestions] = useState([]);
  const [ticketDetails, setTicketDetails] = useState([]);
  const [comments, setComments] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [ticketId, setTicketId] = useState(null);
  const [oneRatingError, setOneRatingError] = useState(false);
  const [ratings, setRatings] = useState([]);
  const [submitted, setSubmitted] = useState(false);
   const [APP_VERSION, setAPP_VERSION] = useState(false);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);
      
        const ticketIdFromUrl = queryParams.get("ticketId") ?? queryParams.get("ticketid");
       
        setTicketId(ticketIdFromUrl);

        const response = await fetch(`${process.env.REACT_APP_FSERVER}/api/feedback/check?ticketId=${ticketIdFromUrl}`);
        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();
        const updatedQuestion = data.questions.map(question => ({
          ...question

        }));
      
        setquestions(updatedQuestion);
        setTicketDetails(data.ticket);
      } catch (error) {
        console.error("Failed to fetch services:", error);
      }
    };
     const fetchVersionNumber = async () => {
      try {
       
        const response = await fetch(`${process.env.REACT_APP_FSERVER}/api/buildVersion/latestVersion`);
        if (!response.ok) console.log("Network response was not ok");

        const data = await response.json();
        setAPP_VERSION(data.versionNumber);
      } catch (error) {
        console.error("Failed to fetch services:", error);
      }
    };


    fetchQuestions();
    fetchVersionNumber();
  }, [location]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const ticketIdFromUrl = queryParams.get("ticketId") ?? queryParams.get("ticketid");
    setTicketId(ticketIdFromUrl);

    if (ticketIdFromUrl) {
      const checkFeedback = async () => {
        try {
          const checkUrl = `${process.env.REACT_APP_FSERVER}/api/feedback/check?ticketId=${ticketIdFromUrl}`;
          const response = await fetch(checkUrl);
          if (response.ok) {
            const feedbackData = await response.json();
            if (feedbackData && feedbackData.exists) {
              navigate(`/thank-you?ticketId=${ticketIdFromUrl}`, { state: feedbackData });
            }
          } else {
            throw new Error("Failed to check feedback status");
          }
        } catch (error) {
          console.error("Error checking feedback status:", error);
        }
      };
      checkFeedback();
    }
  }, [location, navigate]);

  // const questionIds = questions.map((question) => question.id);

  const handleSubmit = async (e) => {

    if (!ticketId) {
      alert("Ticket ID is missing.");
      return;
    }
      setSubmitted(true);

    // Create the `ratings` array in the desired format
    const formattedRatings =questions.map((question) => ({
      ticket_id: ticketId,
      question_id: parseInt(question.id), // Convert the key to an integer
      rating: ratings[question.id] ?? 0,
      comment: comments[question.id] ?? '',
    }));

    const feedbackData = {
      ratings: formattedRatings,
    };

    try {
      const feedbackUrl = `${process.env.REACT_APP_FSERVER}/api/feedback/ratings`;
      const response = await fetch(feedbackUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(feedbackData),
      });

      if (response.ok) {
        navigate(`/thank`);
      } else {
        throw new Error("Failed to submit feedback");
      }
    } catch (error) {
      alert("Error submitting feedback: " + error.message);
    }
  };


  const handleRatingsChange = (questionId, newValue) => {
    setRatings((prev) => ({
      ...prev,
      [questionId]: newValue,
    }));
  };



  const validateForm = () => {
    let isValid = true;
    // Check if at least one rating is provided
    const hasAtLeastOneRating = Object.values(ratings).some((rating) => rating && rating > 0);

    if (!hasAtLeastOneRating) {
      isValid = false;
      setOneRatingError(true)
    }

    return isValid;
  };



  const handleCommentsChange = (questionId, newComment) => {
    setComments((prevComments) => ({
      ...prevComments,
      [questionId]: newComment, // Update only the specific question's comment
    }));
  };
  return (
    <FullScreenContainer>
      <LogoBox>
        <img src="/assets/images/JN_F_Logo.png" alt="Logo" style={{ width: "150px" }} />
      </LogoBox>
      <LandingCurrentDateTime />
  <Container maxWidth="md" sx={{ mt: 10 }}>
        <FormContainer elevation={3} style={{ padding: '20px' }}>
          {/*<Box textAlign="center" mb={3}>
            <FeedbackIcon color="primary" style={{ fontSize: 80 }} />
            <Typography variant="h4" component="h1" gutterBottom>
              We Value Your Feedback!
            </Typography>
            <Typography variant="body1" gutterBottom>
              Please take a moment to share your thoughts about our service. Your feedback helps us improve and serve you better.
            </Typography>
          </Box>*/}
          <Box
            style={{
              fontSize: 20,
              color: '#ffffff',
              backgroundColor: '#02366D',
              padding: '6px',
              textAlign: 'right',
              fontWeight: 'bold'
            }}>
           JN Group
          </Box>
          <Box mb={3}
            style={{
              fontSize: 20,
              color: '#02366D',
              backgroundColor: '#BAD5F2',
              padding: '10px',
              textAlign: 'center'
            }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={{ fontSize: 15, }}>
                  Ticket Number: {ticketDetails?.[0]?.ticketNumber}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={{ fontSize: 15, }}>
                  Time In: {ticketDetails?.[0]?.ticketStartTime}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={{ fontSize: 15, }}>
                  Time Out: {ticketDetails?.[0]?.ticketEndTime}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div style={{ fontSize: 15, }}>
                  Duration:  {ticketDetails?.[0]?.duration}
                </div>
              </Grid>
            </Grid>
          </Box>
          <h5 style={{ fontSize: 20, textAlign: 'center', paddingBottom: '20px' }}>Thank you, {ticketDetails?.[0]?.name}, for visitingJN Group -{ticketDetails?.[0]?.branchName}!</h5>
          <form
            id="feedbackForm"
            onSubmit={(event) => {
              event.preventDefault();
              if (validateForm()) {
                handleSubmit();
              }


            }}
          >
            {questions.map((question, index) => (
              <Box key={index} mb={2} ml={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography align="left">
                      {question.question}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12}>
                    <Rating
                      name={`questionRating${question.id}`}
                      value={ratings[question.id] || 0}
                      onChange={(event, newValue) =>
                        handleRatingsChange(question.id, newValue)
                      }
                    />
                    {/* <TextField
                      id="comments"
                      name="comments"
                      label="Comments"
                      multiline
                      rows={2}
                      value={comments}
                      onChange={(event) => setComments(event.target.value)}
                      variant="outlined"
                      fullWidth sx={{ width: '100%' }}
                    /> */}
                    <TextField
                      id={`comments-${question.id}`}
                      name={`comments-${question.id}`}
                      label="Comments"
                      multiline
                      rows={2}
                      value={comments[question.id] || ''} // Get specific comment
                      onChange={(event) =>
                        handleCommentsChange(question.id, event.target.value)
                      }
                      variant="outlined"
                      fullWidth
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                </Grid>
              </Box>
            ))}

            {/* Comments Field 
            <Box mb={2}>
              <TextField
                id="comments"
                name="comments"
                label="Comments"
                multiline
                rows={2}
                value={comments}
                onChange={(event) => setComments(event.target.value)}
                variant="outlined"
                fullWidth
              />
            </Box>*/}
            {oneRatingError && (
              <Typography color="error" variant="body2">
                Please provide atleast a rating for any of these questions.
              </Typography>
            )}

            {/* Submit Button */}
            {questions && questions.length > 0 && (
                <Box textAlign="center">
                 {!submitted && (
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                    )}
                </Box>
              )}

          </form>
        </FormContainer>
      </Container>

      <Box
        sx={{
          position: "absolute",
          bottom: 10,
          left: 10,
        }}
      >
        <Typography
          variant="caption"
          sx={{ color: "rgba(255, 255, 255, 0.7)", fontWeight: "300" }}
        >
          {APP_VERSION}
        </Typography>
      </Box>
    </FullScreenContainer>

  );
};

export default FeedbackForm;
